import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@shadcn/ui/components/ui/dialog';
import { Button } from '@shadcn/ui/components/ui/button';
import { paths } from '../../../routes/paths';
import { Building2 } from 'lucide-react';
import { useAuth } from '../../providers/authentication-provider';

type SubscriptionIssueDialogProps = {
    organizationName: string;
    activeUsersCount: number;
    children?: ReactNode;
    open?: boolean;
};

const BasicOrganizationInfo = ({
    organizationName,
    activeUsersCount,
}: {
    organizationName: string;
    activeUsersCount: number;
}) => (
    <div className="w-full flex items-center justify-start bg-secondary rounded-t-md mb-4">
        <Building2 className="h-12 w-12" />
        <div className="flex flex-col justify-center ml-4">
            <h3 className="text-lg font-medium text-secondary-foreground uppercase">{organizationName}</h3>
            <p className="text-sm text-secondary-foreground">
                {activeUsersCount} {activeUsersCount === 1 ? 'user' : 'users'}
            </p>
        </div>
    </div>
);

const SubscriptionIssueDialog = ({
    children,
    organizationName,
    activeUsersCount,
    open = true,
}: SubscriptionIssueDialogProps) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <Dialog open={open} modal>
            <DialogContent className="px-8">
                <DialogHeader>
                    <DialogTitle>Subscription info</DialogTitle>
                </DialogHeader>
                <DialogDescription></DialogDescription>
                <div className="flex flex-col gap-2">
                    <BasicOrganizationInfo organizationName={organizationName} activeUsersCount={activeUsersCount} />
                    {children}
                </div>
                <div className="h-px w-full bg-border" />
                <div className="flex justify-center items-center gap-2 text-center">
                    <Button variant="outline" onClick={() => navigate(paths.WORKSPACES.ROOT)}>
                        Exit
                    </Button>
                    <span className="text-muted-foreground">or</span>
                    <Button variant="outline" onClick={() => navigate(paths.WORKSPACES.NEW)}>
                        Create new workspace
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SubscriptionIssueDialog;
